<action-box *ngIf="visible"
            class="visualization-detail detail-item {{extraStyles}}"
            iconLeft="visualization"
            [textLeft]="detailBoxTitle"
            [showHeader]="showDetailBoxHeader">
  <ng-container *ngIf="contentVisible">

    <visualization-panel *ngFor="let visualizationPanel of visualizationPanels"
                         [isEditor]="false"
                         [showTitle]="showPanelTitle"
                         [configurationId]="configurationId"
                         [panel]="visualizationPanel"
                         [id]="visualizationPanel.longId"></visualization-panel>

  </ng-container>
  <div card-type="control" *ngIf="isPrintView">
    <print-checkbox (onValueChange)="onPrintValueChange($event)"></print-checkbox>
  </div>
</action-box>